import {dataURLtoBlob} from "../utils/dataURLtoBlob";
import axios from "axios";

FormData.prototype.appendJson = function (name, value) {
    this.append(name, new Blob([JSON.stringify(value)], {type: "application/json"}))
}

const runningRequests = []

function lockRequest(request) {
    if (runningRequests[request.name]) return Promise.reject({message: "Request is already running"})

    runningRequests[request.name] = true

    return request.finally(() => {
        runningRequests[request.name] = false
    })
}

export function getAllPPays() {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/ppays`);
}

export function getAllDepots() {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/depot/all`)
}

export function getOneDepot(id) {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/depot/${id}`)
}

export async function postDepot(depot, documentsDTOs, documentsIdsToDelete, logo, deleteLogo) {
    const formdata = new FormData()
    formdata.appendJson("dto", depot)
    if (logo) formdata.append("logo", dataURLtoBlob(logo))
    if (deleteLogo) formdata.appendJson("deleteLogo", deleteLogo)

    const docDTOs = []
    for (const doc of documentsDTOs) {
        if (doc.data) {
            formdata.append("documents", dataURLtoBlob(doc.data))
            docDTOs.push({
                ...doc, size: null, data: undefined
            })
        }
    }
    formdata.appendJson("docDTOs", docDTOs)
    formdata.appendJson("docIdsToDelete", documentsIdsToDelete)

    return lockRequest(axios.post(`${process.env.REACT_APP_API_URL}/api/depot/`, formdata, {headers: {'Content-Type': 'multipart/form-data'}}))
}

export function deleteDepot(id) {
    return lockRequest(axios.delete(`${process.env.REACT_APP_API_URL}/api/depot/${id}`))
}

export function generatePdf(ids) {
    return axios.post(`${process.env.REACT_APP_API_URL}/api/depot/pdf`, ids, {responseType: 'blob'})
}

export function generateXLSX(ids, sortModel) {
    return lockRequest(axios.post(`${process.env.REACT_APP_API_URL}/api/depot/xlsx`, {
        ids,
        sortOrder: sortModel?.sort,
        sortColumn: sortModel?.field
    }, {responseType: 'blob'}))
}

export function getLogo(id) {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/depot/${id}/logo`, {responseType: 'blob'})
}
